// Icons
import { ReactComponent as Logo } from './extensionLogo.svg';
import { ReactComponent as Popout } from './popupLink.svg';
import { ReactComponent as SettingsDots } from './settingsDots.svg';
import { ReactComponent as CommandIcon } from './command-icon.svg';
import { ReactComponent as LeaderboardIcon } from './leaderboard.svg';
import { ReactComponent as BitsIndicator } from './bits-indicator.svg';

import { ReactComponent as ConnectToUse } from './connectToUse.svg';
import { ReactComponent as CommandQueued } from './commandQueued.svg';
import { ReactComponent as Error } from './error.svg';
import { ReactComponent as StreamerNoCommand } from './streamerNoCommand.svg';
import { ReactComponent as StreamerNoLeader } from './streamerNoLeader.svg';
import { ReactComponent as FirstPlace } from './firstPlace.svg';
import { ReactComponent as SecondPlace } from './secondPlace.svg';
import { ReactComponent as ThirdPlace } from './thirdPlace.svg';
import { ReactComponent as Hfx } from './hfx.svg';
import { ReactComponent as Play } from './play.svg';

import { ReactComponent as GrayLogo } from './GrayLogo.svg';

import { ReactComponent as ActivateInLumia } from './activate-in-lumia.svg';

import Bits1 from './Bits1.gif';
import Bits2 from './Bits2.gif';
import Bits3 from './Bits3.gif';
import Bits4 from './Bits4.gif';
import Bits5 from './Bits5.gif';

import { ReactComponent as CommandAnimation } from './command-animation-item.svg';
import { ReactComponent as CommandColor } from './command-color-item.svg';
import { ReactComponent as CommandCommand } from './command-command-item.svg';
import { ReactComponent as CommandBuildups } from './command-hypes-item.svg';
import { ReactComponent as CommandInteractive } from './command-interactive-item.svg';
import { ReactComponent as CommandReaction } from './command-reaction-item.svg';
import { ReactComponent as CommandScenes } from './command-scenes-item.svg';
import { ReactComponent as CommandThemes } from './command-themes-item.svg';

import { ReactComponent as LogoTitle } from './LogoTitle.svg';

import { ReactComponent as Trigger } from './Trigger.svg';

import { ReactComponent as Close } from './close.svg';

import { ReactComponent as Offline } from './offlineIcon.svg';
import { ReactComponent as UserGrant } from './userGrant.svg';

import { ReactComponent as FreezBtnItem } from './freezBtnItem.svg';
import { ReactComponent as AvatarFallback } from './avatarFallback.svg';

export default {
	Logo,
	Popout,
	SettingsDots,
	CommandIcon,
	LeaderboardIcon,
	BitsIndicator,
	ConnectToUse,
	CommandQueued,
	Error,
	StreamerNoCommand,
	StreamerNoLeader,
	FirstPlace,
	SecondPlace,
	ThirdPlace,
	GrayLogo,
	LogoTitle,
	Trigger,
	Close,
	Bits1,
	Bits2,
	Bits3,
	Bits4,
	Bits5,
	CommandAnimation,
	CommandColor,
	CommandCommand,
	CommandBuildups,
	CommandInteractive,
	CommandReaction,
	CommandScenes,
	CommandThemes,
	Offline,
	ActivateInLumia,
	FreezBtnItem,
	UserGrant,
	Hfx,
	Play,
	AvatarFallback,
};
